import React, { Component } from "react";
import SingleEmailVerification from "./EmailVerificationContainer/SingleEmailVerification";
import BulkEmailVerification from "./EmailVerificationContainer/BulkEmailVerification";
//import UploadModelDialog from "./EmailVerificationContainer/UploadModelDialog";
import VerifiedJobsList from "./EmailVerificationContainer/EmailVerificationJobs";
import { apiCall } from "../../utility/apiCall";
import Session from "../../utility/session";
import ProfilePopup from "../Login/companyProfilePopup";
import { DISPLAY_COMPANY_PROFILE_POPUP } from "../../common/constants";
import { connect } from "react-redux";
import { showAlert } from "../../utility/alertHelper";
import CountryFormPopup from "../Login/CountryFormPopup";
import { loadCompanyProfileInfo } from "../../Containers/EmailValidation/actions";
class EmailVerification extends Component {
  // state = { showPopup: false, timer: 0, timeLapse:false, isOnlyMins: false, showCountryPopup: false };
  async componentDidMount() {
    // let resp = await apiCall(
    //   "api/company/profile-info",
    //   "GET",
    //   {},
    //   { username: Session.getItem(Session.CURRENT_USER_NAME) }
    // );
    // console.log(resp, "resp")
    // this.setState({
    //   showCountryPopup: resp.data.hasCountry !== undefined ? !resp.data.hasCountry: false,
    //   showPopup: resp.data.showPopup ? true : false,
    //   timer: resp.data.time,
    //   isOnlyMins: resp.data.isOnlyMins,
    //   timeLapse: resp.data.timeLapsed,
    // });

    this.props.dispatch(loadCompanyProfileInfo())
  }
  onOKClick=() => {
    this.props.dispatch({type:DISPLAY_COMPANY_PROFILE_POPUP})
    this.setState({ showPopup: false });
  }
  onResendActivation = async () => {
    let resp = await apiCall("api/company/resend-activation");
    if(resp.success){
      this.setState({ showPopup: false });
      showAlert({
        msg_text: `We have resent the activation Email.`,
        msg_type: "success"
      })
    } else {
      showAlert({
        msg_text: `Something went wrong. Please try again.`,
        msg_type: "error"
      })
    }
  };
  render() {
    return (
      <div className="right_col" role="main">
        <div className="clearfix" />
        {this.props.showCountryPopup ? <CountryFormPopup />  : null}
          {this.props.showPopup && Number(this.props.timer) <= 0 && this.props.showCompanyProfilePopup ? (
          <ProfilePopup 
            onResendActivation={this.onResendActivation} 
            onOKClick={this.onOKClick} 
            timeLapse={this.props.timeLapse}
            timer={this.props.timer}
          />
          ) : (
            <div className="row row-flex">
              {this.props.showPopup && this.props.showCompanyProfilePopup ? showAlert({
                options:{timeOut:0,width:525},
                msg_text: `You will receive an activation Email after ${this.props.timer} ${this.props.isOnlyMins ? "Mins" : "Hours"} to unlock remaining free credits.`,
                msg_type: "info"                
              }) : ""}
              <BulkEmailVerification />
              <SingleEmailVerification />
              <VerifiedJobsList />
            </div>
          )}
        </div>
    );
  }
}


const mapStateToProps = ({emailverificationinfo, companyProfileInfo}) => ({
  showCompanyProfilePopup: emailverificationinfo.showCompanyProfilePopup,
  showPopup: companyProfileInfo.showPopup,
  timer: companyProfileInfo.timer,
  timeLapse: companyProfileInfo.timer,
  isOnlyMins: companyProfileInfo.isOnlyMins,
  showCountryPopup: companyProfileInfo.showCountryPopup
})
export default connect(mapStateToProps)(EmailVerification);



// WEBPACK FOOTER //
// ./src/components/EmailVerification/EmailVerification.js